import { render } from "./FileDetailModal.vue?vue&type=template&id=48eb1b95"
import script from "./FileDetailModal.vue?vue&type=script&lang=js"
export * from "./FileDetailModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__